import { render, staticRenderFns } from "./NERList.vue?vue&type=template&id=48bf8049&"
import script from "./NERList.vue?vue&type=script&lang=js&"
export * from "./NERList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports